import { type AdminDomain } from './admin-domain'
import { type ExpertDomain } from './expert-domain'
import { type MeetingDomain } from './meeting-domain'
import { type ProjectDomain } from './project-domain'
import { type ResearcherDomain } from './researcher-domain'
import { type TaskCollaboratorDomain } from './task-collaborator-domain'
import { type TaskCommentDomain } from './task-comment-domain'

export enum TaskStatus {
  start = 'start',
  profile = 'profile',
  availability = 'availability',
  scheduled = 'scheduled',
  accomplished = 'accomplished',
  canceled = 'canceled',
  refused = 'refused',
  onhold = 'onhold',
  finished = 'finished',
}

export type TaskDomain = {
  id: number
  done: boolean
  name: string
  status: `${TaskStatus}`
  project: ProjectDomain
  admin?: AdminDomain | null
  researcher?: ResearcherDomain | null
  expert: ExpertDomain
  collaborators: TaskCollaboratorDomain[]
  comments: TaskCommentDomain[]
  meeting: MeetingDomain | null
}
